module.exports = __webpack_public_path__ + "static/media/sora_left4f96afaa4d49379def68b48f076a9e28.webp";